// Math round for speed - https://jsperf.com/parsefloat-tofixed-vs-math-round
// same round we are using in Checkout.Frontend
const priceFormatter = (price: number) => (Math.round(price * 100) / 100).toFixed(2);

export default priceFormatter;
